var _defs, _path, _path2, _path3, _path4, _path5, _path6, _ellipse, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewCourseIconCollege(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 400 400",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fb7137;}.cls-2{fill:#04564f;}.cls-3{fill:url(#linear-gradient);}.cls-4,.cls-5,.cls-7{fill:#183332;}.cls-4{opacity:0.1;}.cls-5{opacity:0.3;}.cls-6{fill:url(#linear-gradient-2);}.cls-7{opacity:0.2;}.cls-8{fill:url(#linear-gradient-3);}.cls-9{fill:url(#linear-gradient-4);}.cls-10{fill:#fff;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 491.71,
    y1: 70.27,
    x2: 273.11,
    y2: 119.36,
    gradientTransform: "matrix(0.99, 0.05, 0, 1, 1.73, -13.2)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1aa19c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00706b"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 181.65,
    y1: 124.21,
    x2: 349.94,
    y2: 292.51,
    gradientTransform: "matrix(0.98, 0.06, 0, 1, 5.51, -14.06)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1aa19c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#18ede6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 41.87,
    y1: 218.38,
    x2: 346.19,
    y2: 221.16,
    gradientTransform: "matrix(1, 0.04, 0, 1, 0.07, -5.4)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 181.59,
    y1: 104.1,
    x2: -12.28,
    y2: 108.41,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#048b84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00706b"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M365.27,219.94c-15.27-40.41-87.09-35.41-128-18.68L194.58,181c-6.26-2.61-14.21-.75-19.9,2.77L65.14,255c-3,1.74-5.58,5-5.18,7.92H59.9s1,4.11,3.15,5.18L131.46,302a124.52,124.52,0,0,0-13.24,5h0C98.65,315.07,76.62,333.87,78,351.11c-.4,9.18,4.72,17.45,15.71,22.94,22.81,11.41,62.59,6.78,91.35-10.09,31.65,16.32,87.81,8.63,125.92-16.51,27.4-18.17,37.63-40.53,29.2-57.44A30.38,30.38,0,0,0,333,279.66C361.23,260.82,372.45,237.87,365.27,219.94Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M367.9,66.26c43.11,24,36,69.36-15.89,101.2S223.1,205.63,180,181.59s-36-69.36,15.89-101.21S324.78,42.21,367.9,66.26Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M359,159c-51.13,36.26-134.76,44.83-180.06,19.45-42.75-23.63-36.33-69.31,15.88-101.21,51.89-31.84,128.91-38.17,172-14.12C407.6,85.9,403.45,127.66,359,159Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M329.65,131.73c-7.25,4.44-15.15,9.3-23.51,14.46-45.57-3.29-94.09,8.3-131.18,33.6l-.53.37c-.61-.43-1.21-.86-1.79-1.3l1-.74c-8.91-6.15-16.76-14.85-20.48-24.51-17.65-45.3,30.05-76.88,75.35-92.84L328.88,114C336.89,118,340.22,125.26,329.65,131.73Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M305.46,129.87c-7.57,4.7-16.33,10.15-25.81,16C242.93,148,204.77,159.22,175,179.79l-.53.37c-.61-.43-1.21-.86-1.79-1.3l1-.74c-8.91-6.15-16.76-14.85-20.48-24.51-16-41.32,21.9-71.73,66.06-89.33l88.83,48.87C315,117,314.15,124.57,305.46,129.87Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M368.26,151.93c-53.74,45.24-152.46,51.2-200.36,9C219.18,125,304.88,92.54,368.26,151.93Z"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-2",
    cx: 252.2,
    cy: 197.78,
    rx: 112.35,
    ry: 64.16,
    transform: "translate(-33.35 52.24) rotate(-11.1)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M322.05,236c-42.45,26.19-103.4,33.14-143.69,17.83-46.63-16.53-52.54-62.22-4.68-94.94,46.54-32.68,121.84-39.9,162.79-16.27C375.63,165.13,369.17,206.94,322.05,236Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M286.85,129.13a189.13,189.13,0,0,0-66.1,7.66c-20.59,7.24-40.11,17.41-56.09,31.91v39.18a32.38,32.38,0,0,0,10.74-4L295.82,130C292.89,129.63,289.89,129.34,286.85,129.13Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M164.66,197.78l112.6-69a192.22,192.22,0,0,0-56.51,8c-20.59,7.24-40.11,17.41-56.09,31.91Z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M179.41,253.91c-46.35-16.15-56.34-58.13-8.45-90.41C221,180.3,223.33,228,179.41,253.91Z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M184.14,178.53c30.75,16.52,25.67,48.7-11.32,71.88S80.9,279,50.15,262.5s-25.68-48.71,11.33-71.9S153.4,162,184.14,178.53Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M184.14,176c30.75,16.52,25.67,48.7-11.32,71.88S80.9,276.48,50.15,260s-25.68-48.71,11.33-71.89S153.4,159.48,184.14,176Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M190.48,180c-32.29-22.39-89.9-15.55-128.4,7.72L123,220.14c8.13,3.83,18.57,1.79,26-2.6l48.94-30.47A39.07,39.07,0,0,0,190.48,180Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M184.14,176c-27.29-14.65-73.58-12-109.52,4.93l49.88,26.56c8.14,3.85,18.58,1.81,26-2.59l40-24.9A51.26,51.26,0,0,0,184.14,176Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M297.47,82.79,3.9,126s1.23,5.26,4,6.62L124,190.12c8.14,3.55,18.59,1.12,26-3.54L291,93.61c3.52-2.1,6.33-5.67,6.41-9h0Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M293.16,76.85c7.77,3.65,3.8,11.32-2.12,14.86l-141,93c-7.4,4.66-17.85,7.09-26,3.54L7.92,130.7C.29,127,4.86,119.18,10.59,115.85l140-91.06c7.27-4.51,17.44-6.88,25.43-3.55Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M199.8,76.54c8.36,4.18,12.25,8.83,14,12.41l-17.08,7.34c-5.25-12.24-24.32-17.15-35-9.7-7.23,4.79-5.82,9.09-.22,17.59,7.31,10.85,5.74,19.36-7.41,28.08A57.57,57.57,0,0,1,97,135.76c-8.36-4.17-14.09-10.35-15.54-14.36l17.13-7.62c5.22,14.36,26.63,21.29,39.69,12,7-4.62,7.24-9.28,1.77-17.12-7.45-10-7.55-19.66,5.61-28.38C160.82,70.25,182.87,68.08,199.8,76.54Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewCourseIconCollege);
export default __webpack_public_path__ + "static/media/new-course-icon-college.30d25bea7d461bb23ab16a9a806c1bf0.svg";
export { ForwardRef as ReactComponent };